import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { Location } from '@angular/common';
import { NavigationError } from '@angular/router';
import { OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';
import { ACTIVE_CLIENT } from '../../main';

@Component({
  selector: 'app-error-dialog',
  imports: [MatButtonModule, MatDialogActions, MatDialogTitle, MatDialogContent],
  templateUrl: './error-dialog.html',
  styleUrl: './error-dialog.scss',
})
export class ErrorDialog {
  readonly dialogRef = inject(MatDialogRef<ErrorDialog>);
  readonly location = inject(Location);
  readonly oauth = inject(OAuthService);
  readonly activeClient = inject(ACTIVE_CLIENT);

  constructor(@Inject(MAT_DIALOG_DATA) public data: NavigationError | OAuthErrorEvent) {
    this.dialogRef.disableClose = true;
  }

  protected hideRetry(){
    let hideRetry = true;
    if(this.data instanceof NavigationError){
      if(this.data.error.status > 499) hideRetry = false;
    }

    return hideRetry;
  }

  protected retry() {
    this.dialogRef.close();
    this.location.back();
  }

  protected logout() {
    this.oauth.logOut();
  }

  protected isNavigationError(e: NavigationError | OAuthErrorEvent): e is NavigationError {
    return e instanceof NavigationError;
  }
}
